var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"base-icon-btn"},[_c('span',{staticClass:"base-icon-btn__icon-wrap"},[_vm._t("default")],2),_c('span',{staticClass:"visually-hidden"},[_vm._v(_vm._s(_vm.a11y))])])}
var staticRenderFns = []

export { render, staticRenderFns }